import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import privateAxios from "../../utils/axiosPrivate";
import styles from "./../../assets/scss/custom.module.scss";
import { formatComment, showToast } from "../../utils/utils";
import "./inv-comment.scss";
import { customersDtls, financeTab, tooltips } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { getPostQuoteCommentUrl } from "../../utils/constants/apiEndPoints";
import { sanitizeInput } from "../../utils/utils";

const InvoiceComment = (props) => {
  const { titleText, addText, placeholder, addBtnText, responseMsg, invData } =
    props;

  const [show, setShow] = useState(false);
  const { id } = useParams();
  const [comments, setComments] = useState("");

  const initialComment = {
    generalComment: ""
  };

  const [allComment, setAllComment] = useState(initialComment);

  useEffect(() => {
    if (invData) {
      setComments(invData);
    }
  }, [invData]);

  function toggleShow() {
    setShow(!show);
    setAllComment({
      generalComment: comments?.generalComment || ""
    });
  }

  function handleTextareaChange(event) {
    const value = sanitizeInput(event.target.value);

    setAllComment((prev) => ({
      ...prev,
      generalComment: value
    }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newComment = allComment.generalComment.trim();
    const sanitizedComment = sanitizeInput(newComment);
    const existing = (comments?.generalComment || "").trim();
    if (sanitizedComment === existing) {
      setShow(false);
      return;
    }

    try {
      const formattedComment = formatComment(sanitizedComment);
      const dataToSend = {
        generalComment: formattedComment
      };

      // Make the API call to save the comment
      const response = await privateAxios.post(
        getPostQuoteCommentUrl(id),
        dataToSend
      );

      if (response.status === 200) {
        const updatedComment = response.data?.data?.generalComment;

        setComments((prev) => ({
          ...prev,
          generalComment: updatedComment
        }));

        setAllComment({
          generalComment: ""
        });

        setShow(false);
        showToast(
          `${responseMsg} ${financeTab?.creditScore?.finacialComment.errMsg.item2}`,
          showToastType.success
        );
      }
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
    }
  };

  const buttonText = show
    ? customersDtls.noteCmmnt.CloseBtn
    : `${tooltips.edit} ${addText}`;

  return (
    <>
      <div className={styles.editCommentwrap}>
        <div className={`${styles.labelTitle} mb-0 pb-0`}>
          <h5>
            {titleText}
            <button className={styles.commentAddbtn} onClick={toggleShow}>
              [ {buttonText} ]
            </button>
          </h5>
        </div>
      </div>
      {show && (
        <div className={`${styles.commentArea} ${styles.showCommentArea} my-2`}>
          <textarea
            name="generalComment"
            placeholder={placeholder}
            value={allComment.generalComment}
            onChange={handleTextareaChange}
          />
        </div>
      )}
      {show && (
        <div className={`${styles.commentSubmit}`}>
          <button className="btn-primary btn" onClick={handleSubmit}>
            {addBtnText}
          </button>
        </div>
      )}
      <div className="mb-3 mt-3 cmnt_details">
        <div className={`${styles.commentUpdate} mb-1 pb-1 pt-1`}>
          <div className="cmnt-note">
            <p
              dangerouslySetInnerHTML={{
                __html: sanitizeInput(comments.generalComment)
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
InvoiceComment.propTypes = {
  titleText: PropTypes.string.isRequired,
  addText: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  addBtnText: PropTypes.string.isRequired,
  responseMsg: PropTypes.string,
  invData: PropTypes.shape({
    generalComment: PropTypes.string
  }),
  fetchInvoiceData: PropTypes.func.isRequired
};

export default InvoiceComment;
